import { SystemIcon, Typography } from '@volvo/vcdk-react';
import React from 'react';

import { dates } from '@/utils';
import { cn } from '@/utils/cn';

type TExpirationHours = { hours: number; date?: null };
type TExpirationDate = { date: string; hours?: null };

type TExpiration = TExpirationHours | TExpirationDate;

interface ICoverageExpirationHoursProps {
  isExpired: boolean;
  isCloseToExpired: boolean;
  isReasonForExpiration: boolean;
  expiration: TExpiration;
  isLoading?: boolean;
}

const isHoursExpiration = (obj: TExpiration): obj is TExpirationHours =>
  obj && obj.hours != null && typeof obj.hours === 'number';

const CoverageExpiration: React.FC<ICoverageExpirationHoursProps> = ({
  isExpired,
  isCloseToExpired,
  isReasonForExpiration,
  expiration,
  isLoading = false,
}) => {
  const isHours = isHoursExpiration(expiration);
  const expirationHours = expiration.hours === 99999 ? 'unlimited' : `${expiration.hours} hours`;
  const description = isHours ? expirationHours : dates.formatDate(expiration.date);

  return (
    <div
      className={cn(
        isExpired && 'text-gray-dark',
        isCloseToExpired && 'text-warning',
        isReasonForExpiration && 'line-through'
      )}
    >
      {!!(!isLoading && isHours && isCloseToExpired) && <SystemIcon icon="clock" />}
      <Typography variant="caption1" className="text-subtle">
        {description}
      </Typography>
    </div>
  );
};

export default CoverageExpiration;
